<div class="visit-summary-container">

  <a class="pill pill-review"
     href="{{helpUrl}}"
     target="_blank">
    <i class="fa fa-refresh"></i>
    <span>Model updates available - review</span>
  </a>

  <a class="pill"  [routerLink]="['/scenarios/most-recent']"
     [queryParams]="{ filter: 'shares' }">
    <i class="fa fa-users"></i>
    <span><b>{{sharedDealCount()}}</b> unopened scenarios shared with you</span>
  </a>

  <a class="pill"  [routerLink]="['/scenarios/most-recent']"
     [queryParams]="{ filter: 'updates' }">
    <i class="fa fa-pencil"></i>
    <span><b>{{updatedTowerCount()}}</b> scenarios need updates</span>
  </a>

  <!--maintenance message: only shown while a message is active-->
  @if (maintenanceHtml(); as html) {
  <span class="pill pill-maintenance" [title]="maintenanceText()">
    <i class="fa fa-exclamation-triangle"></i>
    <span class="pill-maintenance-text" [innerHTML]="html"></span>
  </span>
  }

</div>


